import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deployed"},[_c(VSwitch,{attrs:{"label":_vm.serverStatus,"hide-details":""},on:{"change":_vm.changeServerStatus},model:{value:(_vm.serverOnline),callback:function ($$v) {_vm.serverOnline=$$v},expression:"serverOnline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }